/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Search_WebsitesInputs */

const en_common_search_websites = /** @type {(inputs: Common_Search_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search websites...`)
};

const es_common_search_websites = /** @type {(inputs: Common_Search_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar sitios...`)
};

/**
* | output |
* | --- |
* | "Search websites..." |
*
* @param {Common_Search_WebsitesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_search_websites = /** @type {((inputs?: Common_Search_WebsitesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Search_WebsitesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_search_websites(inputs)
	return en_common_search_websites(inputs)
});